import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { CTA, PRICE, DISCOUNT_ENABLED } from "../config/brand";
import { PurchaseButton } from "./PurchaseButton";
import { isDiscountActive } from "../utils/visitorState";

export const MobileStickyCTA = () => {
  const [visible, setVisible] = useState(false);
  const [offerInView, setOfferInView] = useState(false);
  const [discountActive, setDiscountActive] = useState(isDiscountActive());

  useEffect(() => {
    const update = () => setDiscountActive(isDiscountActive());
    window.addEventListener("bp-state", update);
    return () => window.removeEventListener("bp-state", update);
  }, []);

  useEffect(() => {
    const hero = document.getElementById("hero-section");
    const offer = document.getElementById("offer");
    const onScroll = () => {
      const heroBottom = hero ? hero.offsetTop + hero.offsetHeight : 600;
      setVisible(window.scrollY > heroBottom - 120);
    };
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });

    let observer;
    if (offer && "IntersectionObserver" in window) {
      observer = new IntersectionObserver(
        ([entry]) => setOfferInView(entry.isIntersecting),
        { threshold: 0.15 }
      );
      observer.observe(offer);
    }
    return () => {
      window.removeEventListener("scroll", onScroll);
      observer?.disconnect();
    };
  }, []);

  return (
    <AnimatePresence>
      {visible && !offerInView && !(DISCOUNT_ENABLED && discountActive) && (
        <motion.div
          initial={{ y: 90, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 90, opacity: 0 }}
          transition={{ duration: 0.35, ease: [0.22, 1, 0.36, 1] }}
          className="fixed inset-x-0 bottom-0 z-40 px-4 md:hidden"
          style={{ paddingBottom: "calc(env(safe-area-inset-bottom, 0px) + 12px)" }}
          data-testid="mobile-sticky-cta"
        >
          <PurchaseButton
            event="mobile_cta_click"
            testId="mobile-sticky-get-system-button"
            className="flex w-full items-center justify-center gap-2 rounded-xl bg-rose px-6 py-4 text-[13px] font-bold uppercase tracking-[0.1em] text-warmwhite shadow-[0_12px_32px_rgba(90,48,73,0.35)] transition-colors hover:bg-[#b96f84]"
          >
            {CTA.primaryShort} — {PRICE}
          </PurchaseButton>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
